import {Popup} from "./Popup";
import {Toggle} from "./Toggle";
import {Faq} from "./Faq";
import {FixedHeader} from "./FixedHeader";
import {Anchor} from "./Anchor";
import {Tabs} from "./Tabs"
import {MotionOnScroll} from "./MotionOnScroll";
import {Increment} from "./Increment";
import {Scroll} from "./Scroll";
import {CookiesWarning} from "./CookiesWarning";
import {SidebarFixator} from "./SidebarFixator";
import {FormValidator} from "./FormValidator";
import {Responsive} from "./Responsive";
import {DropdownMenu} from "./DropdownMenu";
import {ImageTabs} from "./ImageTabs";

require('@splidejs/splide');
require('@splidejs/splide-extension-url-hash');
const GLightbox = require('glightbox');

// @ts-ignore
const Slider = Splide;
// @ts-ignore
const Extensions = window.splide.Extensions;

document.addEventListener( 'DOMContentLoaded',  () => {
    const theme = window.theme;

    // Creating pop-up windows
    const feedback = new Popup ({
        window: `.feedback-popup`
    });
    feedback.addTriggers(`.feedback-btn, .feedback-popup__close`);
    if (theme.settings.feedback) feedback.toggle();

    const mobileNavigation = new Popup ({
        window: `.dropdown-mobile__navigation`
    });
    mobileNavigation.addTriggers(`.dropdown-mobile__open, .dropdown-mobile__close`);

    // Adding toggles
    const phones = document.querySelectorAll(`.phone-one`);
    phones.forEach(phone => {
        new Toggle({
            triggers: phone.querySelectorAll(`.phone-one__button`),
            target: phone.querySelector(`.phone-one__dropdown`)
        });
    });

    new DropdownMenu({
        triggers: document.querySelectorAll(`.open-dropdown`),
        target: document.querySelector(`.dropdown`),
        frame: document.querySelector(`.dropdown__wrapper`),
        container: document.querySelector(`#header`)
    });

    // Fixing header
    new FixedHeader({
        header: document.querySelector(`#header`),
        content: document.querySelector(`.content`)
    });

    // Initializing responsive menu
    const navigation = new Responsive ({
        container: document.querySelector(`.nav-one__container`),
        list: document.querySelector(`.nav-one__list`),
        dropdown: document.querySelector(`.dropdown-desktop__menu`),
        trigger: document.querySelector(`.nav-one__dropdown`)
    });

    // Scroll
    const scrollTopButton = new Scroll({
        trigger: document.querySelector(`.scroll-top`),
        to: 0,
        offset: 200
    });

    // Anchors
    const anchors = document.querySelectorAll(`.is-anchor`);
    anchors.forEach(element => new Anchor({element: element as HTMLElement}));

    // Faq list
    const faq = document.querySelectorAll(`.faq__question`);
    faq.forEach(element => {
        const faq = new Faq({
            question: element as HTMLElement,
            answer: element.nextElementSibling as HTMLElement
        });
    });

    // Initializing tabs
    const tabs = document.querySelectorAll(`.image-tabs`);
    tabs.forEach(element => {
        new Tabs({
            tabs: element.querySelectorAll(`.image-tabs__tab`),
            content: element.querySelectorAll(`.image-tabs__content-item`)
        })
    });

    const products = document.querySelectorAll(`.product-one`);
    products.forEach(element => {
        new ImageTabs({
            image: element.querySelector(`img`),
            tabs: element.querySelectorAll(`li`)
        })
    });

    // Adding motion on scroll
    const mos = [`.mainscreen`, `.offer`, `.description`, `.text`, `.cards`, `.events`, `.halfscreen`, `.story`, `.products`, `.blog`, `.download`, `.features`];
    for (let i = 0; i < mos.length; i++) {
        const blocks = document.querySelectorAll(mos[i]);
        blocks.forEach(block => new MotionOnScroll(block as HTMLElement));
    }

    // Incrementing Numbers
    const ni = document.querySelectorAll(`.counter-one__number`);
    ni.forEach(element => new Increment({element: element as HTMLElement}));

    // Cookies warning
    new CookiesWarning({
        popup: document.querySelector(`.cookie`),
        trigger: document.querySelector(`.cookie__btn--accept`),
        cookie: `cookiesAgree`
    });

    // Sliders
    const numbers = document.querySelectorAll(`.numbers__splide`);
    numbers.forEach(element => {
        new Slider(element, {
            type: 'loop',
            arrows: true,
            pagination: false,
            speed: 200,
            classes: {
                arrows: 'splide__arrows numbers__arrows',
                arrow : 'splide__arrow numbers__arrow',
                prev  : 'splide__arrow--prev numbers__arrow--prev',
                next  : 'splide__arrow--next numbers__arrow--next',
            },
            breakpoints: {
                '600': {
                    perPage: 1,
                },
                '992': {
                    perPage: 2,
                },
                '1400': {
                    perPage: 3,
                },
            },
            perPage: 4,
            gap: '1rem',
            perMove: 1,
            slideFocus: false,
        }).mount();
    });

    const promotions = document.querySelectorAll(`.promotions__splide`);
    promotions.forEach(element => {
        new Slider(element, {
            type: 'loop',
            arrows: true,
            pagination: false,
            speed: 200,
            classes: {
                arrows: 'splide__arrows promotions__arrows',
                arrow : 'splide__arrow promotions__arrow',
                prev  : 'splide__arrow--prev promotions__arrow--prev',
                next  : 'splide__arrow--next promotions__arrow--next',
            },
            breakpoints: {
                '600': {
                    perPage: 1,
                },
                '1100': {
                    perPage: 2,
                }
            },
            perPage: 3,
            gap: '1rem',
            perMove: 1,
            slideFocus: false,
        }).mount();
    });

    const sliders = document.querySelectorAll(`.slider__splide`);
    sliders.forEach(element => {
        const autoplay = element.hasAttribute(`data-autoplay`);
        const slider = new Slider( element, {
            type: 'fade',
            rewind: true,
            drag: false,
            arrows: false,
            pagination: false,
            speed: 200,
            slideFocus: false,
            autoplay: autoplay,
            pauseOnHover: false,
            pauseOnFocus: false,
        }).mount(Extensions);
    });

    const carousel = document.querySelectorAll(`.carousel__splide`);
    carousel.forEach(element => {
        new Slider(element, {
            type: 'loop',
            arrows: true,
            pagination: false,
            speed: 200,
            breakpoints: {
                '400': {
                    perPage: 1,
                },
                '768': {
                    perPage: 2,
                },
                '992': {
                    perPage: 3,
                },
                '1300': {
                    perPage: 4,
                }
            },
            perPage: 5,
            gap: '1rem',
            perMove: 1,
            classes: {
                arrows: 'splide__arrows carousel__arrows',
                arrow : 'splide__arrow carousel__arrow',
                prev  : 'splide__arrow--prev carousel__arrow--prev',
                next  : 'splide__arrow--next carousel__arrow--next'
            },
            slideFocus: false,
        }).mount();
    });

    const reviews = document.querySelectorAll(`.reviews__splide`);
    reviews.forEach(element => {
        new Slider(element, {
            type: 'loop',
            perPage: 3,
            trimSpace: false,
            pagination: false,
            breakpoints: {
                '500': {
                    perPage: 1,
                },
                '768': {
                    perPage: 1.5,
                },
                '992': {
                    perPage: 2,
                },
                '1200': {
                    perPage: 2.5,
                }
            },
            gap: '1rem',
            perMove: 1,
            slideFocus: false,
            classes: {
                arrows: 'splide__arrows reviews__arrows',
                arrow : 'splide__arrow reviews__arrow',
                prev  : 'splide__arrow--prev reviews__arrow--prev',
                next  : 'splide__arrow--next reviews__arrow--next',
            },
        }).mount();
    });

    const gallery = document.querySelectorAll(`.gallery__splide`);
    gallery.forEach(element => {
        const perPage = (): number[] => {
            if (element.hasAttribute(`fullscreen`)) {
                return [1.3, 1.7, 2.7, 3.7, 4]
            }
            return [1.3, 1.7, 2.5, 2.7, 3];
        };

        new Slider(element, {
            type: 'loop',
            perPage: perPage()[4],
            trimSpace: false,
            arrows: false,
            pagination: false,
            breakpoints: {
                '500': {
                    perPage: perPage()[0],
                },
                '992': {
                    perPage: perPage()[1],
                },
                '1100': {
                    perPage: perPage()[2],
                },
                '1400': {
                    perPage: perPage()[3],
                }
            },
            gap: '2rem',
            perMove: 1,
            slideFocus: false,
        }).mount();
    });

    // Initializing lightboxes
    const lightbox = GLightbox({
        selector: `.g-light-box`,
        svg: {
            close: '',
            next:
                `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40">
                    <path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path>
                </svg>`,
            prev:
                `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40">
                    <path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path>
                </svg>`
        },
        skin: ''
    });

    // Initializing form validator
    const validator = new FormValidator({
        form: document.getElementById(`feedback`),
        name: document.getElementById(`name`) as HTMLInputElement,
        phone: document.getElementById(`phone`) as HTMLInputElement,
        agreement: document.getElementById(`agree`) as HTMLInputElement,
        email: document.getElementById(`email`) as HTMLInputElement
    });

});

window.onload = function() {
    new SidebarFixator({
        sidebar: document.querySelector(`.page-share`),
        footer: document.querySelector(`#footer`)
    });
};